// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"Tyv2locoNQb6bHq2BNdJq","labelContainer":"FI5aPO1BptmU2XOIOGtCf","cancelable":"_370kcz5hgxnXYODVkHjkNG"};